/**
 * valueUtils.js
 * Funções utilitárias para formatação e conversão de valores diversos
 */

/**
 * Formata diferentes tipos de valores para exibição, lidando com arrays, objetos, valores nulos, etc.
 * @param {*} val - Valor a ser formatado
 * @param {string} defaultValue - Valor padrão a ser retornado quando val for null/undefined/vazio
 * @returns {string} - Representação formatada do valor
 */
export function formatValue(val, defaultValue = '--') {
  // Verifica valores nulos, indefinidos ou vazios
  if (val === null || val === undefined || val === '') return defaultValue;

  // Formata arrays em strings separadas por vírgula
  if (Array.isArray(val)) {
    return val.length === 0 ? defaultValue : val.join(', ');
  }

  // Lida com objetos, tentando convertê-los para JSON
  if (typeof val === 'object') {
    try {
      return JSON.stringify(val);
    } catch (_e) {
      return '[Objeto complexo]';
    }
  }

  // Para outros tipos, retorna o valor convertido para string
  return String(val);
}

/**
 * Determina se um campo provavelmente contém uma data
 * @param {string} fieldName - Nome do campo a verificar
 * @returns {boolean} - True se o campo provavelmente contém uma data
 */
export function isDateField(fieldName) {
  if (!fieldName || typeof fieldName !== 'string') return false;

  const datePatterns = [
    /data/i,
    /date/i,
    /dt_/i,
    /_dt$/i,
    /criacao/i,
    /criação/i,
    /emissao/i,
    /emissão/i,
    /vencimento/i,
    /expiracao/i,
    /expiração/i,
    /aprovacao/i,
    /aprovação/i,
    /cadastro/i,
    /registro/i,
  ];

  return datePatterns.some((pattern) => pattern.test(fieldName));
}
